import React from 'react';
import { faRunning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './RunningButton.module.css';
import { CommonButton } from '_components';


export class RunningButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : ''} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faRunning} transform="shrink-6" color="#717271" />
            </CommonButton>
        );
    }
}
